module.exports = __webpack_public_path__ + "static/media/logo-gpc.33a81e05.png";